import src from "IMAGE";
export default { src, width: 16, height: 16, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
